export default "__VITE_ASSET__Dgpn7jJt__"